import { render, staticRenderFns } from "./NowhowDatebox.vue?vue&type=template&id=67432696"
import script from "./NowhowDatebox.vue?vue&type=script&lang=ts"
export * from "./NowhowDatebox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports